import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import WashNFold from "../assets/webp/WashNFold.webp";
import DryCleaning from "../assets/webp/DryCleaning.webp";
import Tailoring from "../assets/webp/Tailoring.webp";

export const cart_item = [
  {
    id: 1,
    name: "Pj’s set of 2",
    quantity: 1,
    price: 10,
    icon: LocalLaundryServiceIcon, // Replace with your actual asset
    services: [],
  },
  {
    id: 2,
    name: "Jeans",
    quantity: 4,
    price: 30,
    icon: LocalLaundryServiceIcon,
    services: ["Washing", "Ironing", "Drycleaning"],
  },
]

export const services = [
  {
    title: "Wash & Fold",
    icon: WashNFold,
  },
  {
    title: "Dry Cleaning",
    icon: DryCleaning,
  },
  {
    title: "Tailoring",
    icon: Tailoring,
  },
];

export const servicesArray = [ "Wash & Fold", "Dry Cleaning", "Tailoring"];

export const selectedServiceText = {
  // "Wash & Fold": "Ideal for your everyday laundry. We wash, dry, and neatly fold your clothes so they're fresh and ready to wear.",
  "Wash & Fold": "No heavy bags. No wasted weekends. Just fresh, clean, and ready-to-wear clothes—without the stress",
  "Dry Cleaning": "No heavy bags. No wasted weekends. Just fresh, clean, and ready-to-wear clothes—without the stress",
  // "Dry Cleaning": "Professional care for delicate fabrics and formal wear. Stains removed, fabrics preserved, and garments returned crisp.",
  "Tailoring": "Get the perfect fit. From hemming to alterations, our expert tailors ensure your clothes look and feel just right."
};

export const statusToStepMap = {
  "Pending": "Pending",
  "Confirmed": "Confirmed",
  "Pickup Scheduled": "Confirmed",
  "Pickup Rescheduled": "Confirmed",
  "Pickup Confirmed": "Confirmed",
  "Out for Pickup": "Scheduled",
  "Picked Up": "Picked Up",
  "At Store": "Processing",
  "Processing": "Processing",
  "Delayed": "Processing",
  "Ready for Delivery": "Processing",
  "Out for Delivery": "Out For Delivery",
  "Delivered": "Delivered"
};


export const statusClasses = {
  "confirmed": "bg-green-100 text-green-800",
  "scheduled": "bg-yellow-100 text-yellow-800",
  "picked-up": "bg-blue-100 text-blue-800",
  "processing": "bg-purple-100 text-purple-800",
  "out-for-delivery": "bg-orange-100 text-orange-800",
  "delivered": "bg-green-100 text-green-800",
  "pending": "bg-amber-100 text-amber-800",
  "ready for delivery":"bg-sky-100 text-sky-800",
  "at store":"bg-sky-100 text-sky-800",
};